import { render, staticRenderFns } from "./ExchRate.vue?vue&type=template&id=4379be5c"
import script from "./ExchRate.vue?vue&type=script&lang=js"
export * from "./ExchRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports